import React, { useState, useEffect } from "react";
import cn from "classnames";
import Card from "../../../components/Card";
import styles from "./Products.module.sass";
import Icon from "../../../components/Icon";
import ArticleCard from "../../../components/ArticleCard";
import Slider from "react-slick";

// data
import { getCarrouselArticles } from "../../../services/article.service";

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const ArticleCarousel = ({className, currentUser}) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-right" size="24" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-left" size="24" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        // Récupérer les articles pour le carrousel
        const carrouselArticles = await getCarrouselArticles();
        setArticles(carrouselArticles);
      } catch (error) {
        console.error('Erreur lors de la récupération des articles:', error);
        setArticles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return (
      <Card
        className={cn(styles.card, className)}
        title="Articles"
        classTitle="title-green"
      >
        <div className={styles.products}>
          <div className={styles.wrapper}>
            <p>Chargement des articles...</p>
          </div>
        </div>
      </Card>
    );
  }

  if (articles.length === 0) {
    return (
      <Card
        className={cn(styles.card, className)}
        title="Articles"
        classTitle="title-green"
      >
        <div className={styles.products}>
          <div className={styles.empty}>
            Aucun article disponible pour le moment.
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card
      className={cn(styles.card, className)}
      title="Articles"
      classTitle="title-green"
    >
      <div className={styles.products}>
        <div className={styles.wrapper}>
          <Slider className="products-slider" {...settings}>
            {articles.map((article, index) => (
              <ArticleCard
                className={styles.product}
                item={article}
                key={article.id || index}
                withoutСheckbox
              />
            ))}
          </Slider>
        </div>
      </div>
    </Card>
  );
};

export default ArticleCarousel;
